/**
 * Impl dos use cases de admin de Requerimento (acadadmin).
 *
 * @since G.5.15
 */
import type { Page } from '@/domain/model/Page';
import type {
  Requerimento, RequerimentoTipo, RequerimentoEtapa,
  RequerimentoHistorico, RequerimentoPagamento,
  RequerimentoTipoCommand, DecidirEtapaCommand,
  PedirComplementacaoCommand, ReverterRequerimentoCommand,
} from '@/domain/model/Requerimento';
import type {
  RequerimentoAdminGateway, ListRequerimentoTiposParams,
  ListRequerimentosParams, FilaRequerimentoParams,
} from '@/application/port/out/RequerimentoAdminGateway';
import type {
  ListRequerimentoTiposUseCase, CreateRequerimentoTipoUseCase, UpdateRequerimentoTipoUseCase,
  DeactivateRequerimentoTipoUseCase, ListRequerimentosUseCase, GetRequerimentoUseCase,
  ListRequerimentoHistoricoUseCase, FilaRequerimentoUseCase, ClaimRequerimentoEtapaUseCase,
  DecidirRequerimentoEtapaUseCase, PedirComplementacaoRequerimentoUseCase,
  ReenviarRequerimentoUseCase, ReverterRequerimentoUseCase,
  GetRequerimentoPagamentoUseCase, ConfirmarRequerimentoPagamentoUseCase,
} from '@/application/port/in/RequerimentoAdminUseCase';

export class ListRequerimentoTipos implements ListRequerimentoTiposUseCase {
  constructor(private readonly g: RequerimentoAdminGateway) {}
  execute(params: ListRequerimentoTiposParams): Promise<Page<RequerimentoTipo>> { return this.g.listTipos(params); }
}
export class CreateRequerimentoTipo implements CreateRequerimentoTipoUseCase {
  constructor(private readonly g: RequerimentoAdminGateway) {}
  execute(cmd: RequerimentoTipoCommand): Promise<RequerimentoTipo> { return this.g.createTipo(cmd); }
}
export class UpdateRequerimentoTipo implements UpdateRequerimentoTipoUseCase {
  constructor(private readonly g: RequerimentoAdminGateway) {}
  execute(id: string, cmd: RequerimentoTipoCommand): Promise<RequerimentoTipo> { return this.g.updateTipo(id, cmd); }
}
export class DeactivateRequerimentoTipo implements DeactivateRequerimentoTipoUseCase {
  constructor(private readonly g: RequerimentoAdminGateway) {}
  execute(id: string): Promise<void> { return this.g.deactivateTipo(id); }
}
export class ListRequerimentos implements ListRequerimentosUseCase {
  constructor(private readonly g: RequerimentoAdminGateway) {}
  execute(params: ListRequerimentosParams): Promise<Page<Requerimento>> { return this.g.listFiltered(params); }
}
export class GetRequerimento implements GetRequerimentoUseCase {
  constructor(private readonly g: RequerimentoAdminGateway) {}
  execute(id: string): Promise<Requerimento> { return this.g.get(id); }
}
export class ListRequerimentoHistorico implements ListRequerimentoHistoricoUseCase {
  constructor(private readonly g: RequerimentoAdminGateway) {}
  execute(id: string): Promise<RequerimentoHistorico[]> { return this.g.historico(id); }
}
export class FilaRequerimento implements FilaRequerimentoUseCase {
  constructor(private readonly g: RequerimentoAdminGateway) {}
  execute(params: FilaRequerimentoParams): Promise<Page<RequerimentoEtapa>> { return this.g.fila(params); }
}
export class ClaimRequerimentoEtapa implements ClaimRequerimentoEtapaUseCase {
  constructor(private readonly g: RequerimentoAdminGateway) {}
  execute(etapaId: string): Promise<RequerimentoEtapa> { return this.g.claimEtapa(etapaId); }
}
export class DecidirRequerimentoEtapa implements DecidirRequerimentoEtapaUseCase {
  constructor(private readonly g: RequerimentoAdminGateway) {}
  execute(etapaId: string, cmd: DecidirEtapaCommand): Promise<Requerimento> { return this.g.decidirEtapa(etapaId, cmd); }
}
export class PedirComplementacaoRequerimento implements PedirComplementacaoRequerimentoUseCase {
  constructor(private readonly g: RequerimentoAdminGateway) {}
  execute(id: string, cmd: PedirComplementacaoCommand): Promise<Requerimento> { return this.g.pedirComplementacao(id, cmd); }
}
export class ReenviarRequerimento implements ReenviarRequerimentoUseCase {
  constructor(private readonly g: RequerimentoAdminGateway) {}
  execute(id: string): Promise<Requerimento> { return this.g.reenviar(id); }
}
export class ReverterRequerimento implements ReverterRequerimentoUseCase {
  constructor(private readonly g: RequerimentoAdminGateway) {}
  execute(id: string, cmd: ReverterRequerimentoCommand): Promise<Requerimento> { return this.g.reverter(id, cmd); }
}
export class GetRequerimentoPagamento implements GetRequerimentoPagamentoUseCase {
  constructor(private readonly g: RequerimentoAdminGateway) {}
  execute(id: string): Promise<RequerimentoPagamento | null> { return this.g.getPagamento(id); }
}
export class ConfirmarRequerimentoPagamento implements ConfirmarRequerimentoPagamentoUseCase {
  constructor(private readonly g: RequerimentoAdminGateway) {}
  execute(id: string): Promise<RequerimentoPagamento> { return this.g.confirmarPagamento(id); }
}
